module.exports = __webpack_public_path__ + "static/img/2.4ca93a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/在线教育/2.png
// module id = y5bS
// module chunks = 1